import { UserTeamsPayload } from 'components/usersTable/types';
import { UserTeam } from 'contexts/teams/types';

export type InviteWithTeams = {
  userTeams?: UserTeam[];
  teams?: UserTeamsPayload[];
};

export const buildInvitesWithTeams = <T extends InviteWithTeams>(invites: T[]): T[] => {
  return invites.map((invite) => {
    const teamsSource = invite.userTeams;
    if (!teamsSource || teamsSource.length === 0) {
      return { ...invite, userTeams: [], teams: [] } as T;
    }
    const teams = teamsSource.map((userTeam) => ({
      team_id: userTeam.team?.id || userTeam.team?.team_id || userTeam.team_id,
      is_manager: userTeam.is_manager,
    }));
    return { ...invite, userTeams: teamsSource, teams } as T;
  });
};
